export const baudData = [
    { key: '1200', value: '1200' },
    { key: '2400', value: '2400' },
    { key: '4800', value: '4800' },
    { key: '9600', value: '9600' },
    { key: '19200', value: '19200' },
    { key: '38400', value: '38400' },
    { key: '57600', value: '57600' },
    { key: '115200', value: '115200' },
    { key: '230400', value: '230400' },
    { key: '460800', value: '460800' },
    { key: '921600', value: '921600' },
];

export const starBaudData = [
    { key: '75', value: '75' },
    { key: '110', value: '110' },
    { key: '134', value: '134' },
    { key: '150', value: '150' },
    { key: '300', value: '300' },
    { key: '600', value: '600' },
    { key: '1200', value: '1200' },
    { key: '2400', value: '2400' },
    { key: '4800', value: '4800' },
    { key: '9600', value: '9600' },
    { key: '19200', value: '19200' },
    { key: '38400', value: '38400' },
    { key: '57600', value: '57600' },
    { key: '115200', value: '115200' }
];
export const bits = [
    { key: 5, value: '5' },
    { key: 6, value: '6' },
    { key: 7, value: '7' },
    { key: 8, value: '8' },
    { key: 9, value: '9' },
];
export const starBits = [
    { key: 5, value: '5' },
    { key: 6, value: '6' },
    { key: 7, value: '7' },
    { key: 8, value: '8' },
];
export const term = [
    { key: 'OFF', value: 'OFF' },
    { key: 'ON', value: 'ON' },
];
export const standard = [
    { key: '232', value: 'RS-232' },
    { key: '485', value: 'RS-485' },
];
export const stop = [
    { key: 0, value: '0' },
    { key: 1, value: '1' },
];
export const starStop = [
    { key: 1, value: '1' },
    { key: 1.5, value: '1.5' },
    { key: 2, value: '2' },
];
export const parity = [
    { key: 'N', value: 'None' },
    { key: 'E', value: 'Even' },
    { key: 'O', value: 'Odd' },
];
export const starfishParity = [
    { key: 'None', value: 'None' },
    { key: 'Even', value: 'Even' },
    { key: 'Odd', value: 'Odd' },
    { key: 'Mark', value: 'Mark' },
    { key: 'Space', value: 'Space' },
];
export const communicationType = [
    { key: 'SERIAL', value: 'SERIAL' },
    { key: 'TCP', value: 'TCP' },
    
];
export const pushRate = [
    { key: '1', value: '00:01m' },
    { key: '5', value: '00:05m' },
    { key: '15', value: '00:15m' },
    { key: '60', value: '01:00hr' },
    { key: '240', value: '04:00hr' },
    { key: '480', value: '08:00hr' },
    { key: '720', value: '12:00hr' },
    { key: '1440', value: '24:00hr' },
];
export const com = [
    { key: '0', value: 'COM3' },
    { key: '1', value: 'COM15' },
    
];

export const isDisarm = [
    { key: 0, value: 'Disabled' },
    { key: 1, value: 'Enabled' },
];

export const isActive = [
    { key: 0, value: 'Active' },
    { key: 1, value: 'Inactive' },
];


